import createCachedSelector from 're-reselect';

import { State } from '../../typings/state';

export const selectCampaignServiceEditorData = createCachedSelector(
    (state: State, editorId: string) => state.campaignServiceEditor[editorId],
    editorData => editorData
)((state: State, editorId: string): string => editorId);
